module.exports = __webpack_public_path__ + "media/zoho/zoho_faq3-da9a514d.png";